export const en = {
    'switch-to-old-interface': 'If the error persists, you can return to the old interface',
    'switch-to-old-interface-link': 'Return to the old interface'
};
